export default __webpack_public_path__ + "static/media/check.033cc3e6.png";